__turbopack_context__.v({
  "appOnlyBadge": "contentcard-module-scss-module__KQKxmq__appOnlyBadge",
  "audioPlayerWrapper": "contentcard-module-scss-module__KQKxmq__audioPlayerWrapper",
  "body": "contentcard-module-scss-module__KQKxmq__body",
  "buttonWrapper": "contentcard-module-scss-module__KQKxmq__buttonWrapper",
  "cardHover": "contentcard-module-scss-module__KQKxmq__cardHover",
  "cardLink": "contentcard-module-scss-module__KQKxmq__cardLink",
  "carouselArrows": "contentcard-module-scss-module__KQKxmq__carouselArrows",
  "carouselSlide": "contentcard-module-scss-module__KQKxmq__carouselSlide",
  "carouselTrack": "contentcard-module-scss-module__KQKxmq__carouselTrack",
  "channelLogo": "contentcard-module-scss-module__KQKxmq__channelLogo",
  "contentCard": "contentcard-module-scss-module__KQKxmq__contentCard",
  "contentContainer": "contentcard-module-scss-module__KQKxmq__contentContainer",
  "contentText": "contentcard-module-scss-module__KQKxmq__contentText",
  "copyright": "contentcard-module-scss-module__KQKxmq__copyright",
  "eyebrow": "contentcard-module-scss-module__KQKxmq__eyebrow",
  "eyebrowWithBadge": "contentcard-module-scss-module__KQKxmq__eyebrowWithBadge",
  "eyebrowWrapper": "contentcard-module-scss-module__KQKxmq__eyebrowWrapper",
  "featuredGroup": "contentcard-module-scss-module__KQKxmq__featuredGroup",
  "group": "contentcard-module-scss-module__KQKxmq__group",
  "groupGridWrapper": "contentcard-module-scss-module__KQKxmq__groupGridWrapper",
  "horizontalGroup": "contentcard-module-scss-module__KQKxmq__horizontalGroup",
  "horizontalSingleColumn": "contentcard-module-scss-module__KQKxmq__horizontalSingleColumn",
  "imageContainer": "contentcard-module-scss-module__KQKxmq__imageContainer",
  "imageRight": "contentcard-module-scss-module__KQKxmq__imageRight",
  "leftArrow": "contentcard-module-scss-module__KQKxmq__leftArrow",
  "link": "contentcard-module-scss-module__KQKxmq__link",
  "mediaContainer": "contentcard-module-scss-module__KQKxmq__mediaContainer",
  "noGridSpacing": "contentcard-module-scss-module__KQKxmq__noGridSpacing",
  "rightArrow": "contentcard-module-scss-module__KQKxmq__rightArrow",
  "smallVerticalMedia": "contentcard-module-scss-module__KQKxmq__smallVerticalMedia",
  "textCenter": "contentcard-module-scss-module__KQKxmq__textCenter",
  "title": "contentcard-module-scss-module__KQKxmq__title",
  "titleHover": "contentcard-module-scss-module__KQKxmq__titleHover",
  "truncated": "contentcard-module-scss-module__KQKxmq__truncated",
  "verticalGroup": "contentcard-module-scss-module__KQKxmq__verticalGroup",
  "videoContainer": "contentcard-module-scss-module__KQKxmq__videoContainer",
  "withReadmore": "contentcard-module-scss-module__KQKxmq__withReadmore",
});
